/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
export default class AchievementCategoryDesc extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const {
      category
    } = this.attrs;
    if (!category.description()) {
      return null;
    }
    return m("div", {
      className: "AchievementCategoryDesc"
    }, category.description());
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/components/AchievementCategoryDesc', AchievementCategoryDesc);